<template>
    <li class="doughnut-footer-item">
        <div>
            <div class="circle" :style="{ 'border-color': color }"></div>
        </div>

        <div class="label">
            {{ label }}
        </div>

        <div class="doughnut-footer-item-data">
            {{ formatedValue }}
        </div>

        <div
            class="doughnut-footer-item-data text-sm"
            :style="{ color: color }"
        >
            ({{ percentage }}%)
        </div>
    </li>
</template>

<script>
import colors from "@packages/colors";
import provider from "@mixins/provider";

export default {
    props: {
        value: {
            type: Number,
        },
        label: {
            type: String,
        },
        total: {
            type: Number,
        },
        index: {
            type: Number,
        },
    },

    mixins: [provider],

    computed: {
        percentage() {
            return this.total !== 0
                ? Math.round((this.value / this.total) * 100)
                : 0;
        },

        color() {
            const backgroundColor =
                {
                    vivo: colors.vivo.charts.doughnut,
                    unifique: colors.unifique.charts.doughnut,
                    abc: colors.abc.charts.doughnut,
                    vero: colors.vero.charts.doughnut,
                    wifeed: colors.charts.doughnut,
                    wcs: colors.charts.doughnut,
                    haggi: colors.charts.doughnut,
                    tely: colors.charts.doughnut,
                    ntcorp: colors.charts.doughnut,
                    "data-carrier": colors.charts.doughnut,
                }[this.savedProvider] || colors.charts.doughnut;

            return backgroundColor[this.index];
        },

        formatedValue() {
            return new Intl.NumberFormat("pt-BR").format(this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.doughnut-footer-item {
    width: 100%;
    display: grid;
    grid-template-columns: 30px auto auto 40px;
    font-size: 16px;

    &:not(:first-child) {
        margin-top: 14px;
    }

    > * {
        display: flex;
        align-items: center;
    }

    .circle {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        border: 3px solid;
    }

    .label {
        margin-right: 6px;
    }

    .doughnut-footer-item-data {
        display: flex;
        justify-content: flex-end;
    }

    @media (max-width: 1700px) {
        font-size: 14px;
    }
}
</style>
